import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { reducer, config as CognitoConfig } from '../../redux/sagas/aws-cognito-redux-saga';
import config from '../../config';

class Auth extends React.Component {
  static propTypes = {
    getUser: PropTypes.func.isRequired,
  };

  componentWillMount() {
    CognitoConfig.config.set({
      region: config.COGNITO_REGION,
      UserPoolId: config.COGNITO_USERPOOL,
      ClientId: config.COGNITO_CLIENTID,
    });

    this.props.getUser();
  }

  render() {
    return null;
  }
}

const mapStatetoProps = () => ({});

const mapDispatchToProps = dispatch => ({
  getUser: () => {
    dispatch(reducer.getUser());
  },
});

export default connect(mapStatetoProps, mapDispatchToProps)(Auth);



// WEBPACK FOOTER //
// ./src/components/Auth/Auth.js